import svg from "./scatterplot-candidate-base-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const ScatterplotPioneerIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.candidate.light,
);

export default ScatterplotPioneerIcon;
